<template>
<div class="smart-form">
  <div class="smart-icon">
      <img src="../assets/bahn.png" width="120px"/>
     </div>
    <div class="screentime-hl">Wie viel Prozent des deutschen Bahnnetzes ist verstromt?</div>
    
  <div class="screentime-form">
      <form v-if="hasQuizForm"> 
        <br>
           <div class="inner-form">
         <button class="gen_button" v-on:click.prevent="generateOption1">86%</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption2">61%</button>
          &nbsp;&nbsp;
         <button class="gen_button" v-on:click.prevent="generateOption3">42%</button>
<br>
 <br>
</div></form>
  </div>
  <div v-if="hasChoosen" class="smartphone-dataviz">
  <br>
         <div class="screentime-description" v-html="quizDescription"> <br><br>
        </div>
    <br><br>
   <div class="dataviz-source"> Quelle: Deutsche Bahn</div>
  </div>
  </div>
</template>


<script>
export default {
  name: 'Quiz',
  props: {
    
  },
  data() {
        return {
            optionChoosen: "",
            hasChoosen: false,
            hasQuizForm:true       }     
    },
    computed: {
       
         quizDescription: function () {
        let smartAppMsg="";
        
            if (this.optionChoosen == "Option1") {
                smartAppMsg= "Sie wählten 42%. Ganz so wenig ist es nicht.<br><br><b>61% </b><br>des Deutschen Bahnnetzes sind verstromt. Damit liegt die Bundesrepublik zwar über dem EU-Durchschnitt, aber deutlich hinter den führenden Ländern.<br><br><b>100% </b><br>des Bahnnetzes sind in der Schweiz verstromt.<br>86% in Belgien <br>76% in Niederlanden"
            }
            if (this.optionChoosen == "Option2") {
                smartAppMsg= "Sie liegen goldrichtig! <br><br><b>61% </b><br>des Deutschen Bahnnetzes sind verstromt. Damit liegt die Bundesrepublik zwar über dem EU-Durchschnitt, aber deutlich hinter den führenden Ländern.<br><br><b>100% </b><br>des Bahnnetzes sind in der Schweiz verstromt.<br>86% in Belgien <br>76% in Niederlanden"
            }
            if (this.optionChoosen == "Option3") {
                smartAppMsg= "Sie wählten 86%. Soweit ist die Bahn noch nicht.<br><br><b>61% </b><br>des Deutschen Bahnnetzes sind verstromt. Damit liegt die Bundesrepublik zwar über dem EU-Durchschnitt, aber deutlich hinter den führenden Ländern.<br><br><b>100% </b><br>des Bahnnetzes sind in der Schweiz verstromt.<br>86% in Belgien <br>76% in Niederlanden"
            }
                        
            return (smartAppMsg)
            }
            
       

    },
  methods: {
        generateOption1: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option1";
           
           }  
        },
         generateOption2: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option2";
           
           }  
        },
         generateOption3: function () {
            if (this.hasChoosen==true){
                this.hasChoosen = false;
                this.optionChoosen = "";
            } else {
            this.hasChoosen=true;
             this.hasQuizForm = false;
             this.optionChoosen = "Option3";
           
           }  
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/styles.css';
</style>
